import { getEntities } from 'entman';

import schemas from 'schemas';


export function getInvoices(state) {
  return getEntities(state, schemas.Invoice);
}
